import api from '@/utils/api';

/**
 * Get Product Categories
 * @param {string} companyId - the companyId
 * @param {string} query - query
 * @returns {Promise}
 */
const getProductCategoriesApi = (companyId, query) => {
  const url = query
    ? `/company/${companyId}/product-category?${query}`
    : `/company/${companyId}/product-category`;
  return api.get(url);
};
export default getProductCategoriesApi;
